module.exports = __webpack_public_path__ + "img/fi-korean-food-600x395.4342365b.jpg";